export default "__VITE_ASSET__CXHdj2EZ__"